import type { ScheduleGridKind } from '../types';

export const queryKeys = {
  driverAvailability: {
    all: ['driver-availability'] as const,
    submissions: () => ['driver-availability', 'submissions'] as const,
    links: () => ['driver-availability', 'links'] as const,
    targetWeeks: () => ['driver-availability', 'target-weeks'] as const,
    windowCatalog: () => ['driver-availability', 'window-catalog'] as const,
    publicLink: (token: string) => ['driver-availability', 'public-link', token] as const,
  },
  weekCalendar: {
    all: ['week-calendar'] as const,
    blocked: () => ['week-calendar', 'blocked'] as const,
    normal: (week: string, visibleDays: number) =>
      ['week-calendar', 'normal', week, visibleDays] as const,
    custom: (rangeStart: string, rangeEnd: string) =>
      ['week-calendar', 'custom', rangeStart, rangeEnd] as const,
  },
  driverAvailabilityCampaigns: {
    all: ['driver-availability-campaigns'] as const,
    list: () => ['driver-availability-campaigns', 'list'] as const,
    detail: (id: number) => ['driver-availability-campaigns', 'detail', id] as const,
    worker: () => ['driver-availability-campaigns', 'worker'] as const,
    public: (token: string) => ['driver-availability-campaigns', 'public', token] as const,
  },
  timeContext: {
    current: () => ['time-context'] as const,
  },
  scheduleIntelligence: {
    all: ['schedule-intelligence'] as const,
    driverStatus: (currentWeek: string, identity: 'driver_id' | 'name') =>
      ['schedule-intelligence', 'driver-status', identity, currentWeek] as const,
    heatmap: (start: string, end: string) =>
      ['schedule-intelligence', 'heatmap', start, end] as const,
  },
  slotOverrides: {
    all: ['slot-overrides'] as const,
    week: (week: string, grid: ScheduleGridKind) =>
      ['slot-overrides', week, grid] as const,
  },
  fleetAssets: { all: ['fleet-assets'] as const },
  fleetRepair: { all: ['fleet-repair'] as const },
  truckDispatch: { all: ['truck-dispatch'] as const },
};
